module.exports = __webpack_public_path__ + "./docs/img/icon-search-grayscale.0bf6559c2b6078da0b87ac260adeec12.svg";